/**
 *
 * MenuItem
 *
 */

import React, { memo } from 'react';

import { StyledMenuItem } from './Menu.styles';

function MenuItem({ ...props }) {
  return <StyledMenuItem {...props} />;
}

export default memo(MenuItem);
